<template>
    <div class="v-recover-password">

        <template v-if="!success">

            <h1 class="v-recover-password__heading">
                {{ $t('recoverPassword.heading') }}
            </h1>

            <form @submit.prevent="recover" class="v-recover-password__form">

                <div class="v-recover-password__username">
                    <v-input
                            v-model="email"
                            :darkTheme="true"
                            :label="$t('recoverPassword.input.label')"
                    />
                </div>

                <div class="v-recover-password__error"
                     :class="{'v-recover-password__error--visible': error}">
                    {{ errorMessage }}
                </div>

                <div class="v-recover-password__submit">
                    <eda-button class="v-recover-password__button"
                                :error="error"
                                :label="$t('recoverPassword.submit')"
                                :loading="sendingRequest"></eda-button>
                </div>
            </form>

            <div class="v-recover-password__login">
                {{ $t('recoverPassword.login.heading') }}
                <span class="v-recover-password__login-link">
                    <eda-link to="/">
                         {{ $t('recoverPassword.login.link') }}
                    </eda-link>
                </span>
            </div>
        </template>
        <template v-else>

            <h1 class="v-recover-password__heading">
                {{ $t('recoverPassword.mailSent') }}
            </h1>

            <div class="v-recover-password__instructions">
                {{ $t('recoverPassword.followMailInstructions') }}
            </div>

        </template>
    </div>
</template>

<script>
  import axios from 'axios';
  import EdaButton from "../components/vButton"
  import EdaLink from "../components/vLink"
  import vInput from "../components/vInput"
  import { mapActions } from 'vuex';
  import api from "../mixins/apiMixin.js"

  export default {
    name: "v-recover-password",
    components: {
      EdaButton,
      vInput,
      EdaLink
    },
    mixins: [
      api.apiMixin
    ],
    props: {
      errorMessages: {
        type: Object, default() {
          // todo: make translatable
          return {
            400: "Du har ikke angitt kontekst for forespørselen",
            404: "Det finnes ingen bruker med denne eposten i vårt system",
            500: "Noe gikk galt på vår side. Prøv igjen senere, og ta kontakt med oss hvis problemet vedvarer",
          }
        }
      },
    },
    data: function () {
      return {
        email: "",
        password: "",
        errorCode: 0,
        success: false,
        error: false,
        sendingRequest: false,
      }
    },
    computed: {
      errorMessage() {
        return (this.error && this.errorCode) ? this.errorMessages[this.errorCode] : "";
      }
    },
    methods: {
      ...mapActions([
        "setUser"
      ]),
      recover() {
        var that = this;
        that.error = false;
        that.sendingRequest = true;
        axios.post(process.env.VUE_APP_API_URL + "/users/recover", {
          "email": that.email,
          "context": "retailer",
          "appUrl": window.location.protocol + "//" + window.location.hostname,
          "recoverUrl": window.location.protocol + "//" + window.location.hostname + "/#/user/reset/:hash"
        }, that.apiHeaders).then(function (response) {
          that.success = true;
        }).catch(function (error) {
          that.errorCode = error.response.status;
          that.error = true;
        }).finally(function () {
          that.sendingRequest = false;
        });
      }
    }
  }

</script>

<style lang="scss">


    .v-recover-password {
        display: flex;
        padding-top: 4vw;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 1.1em;
        color: white;

        &__heading {
            font-weight: 600;
        }

        &__form {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
        }

        &__username,
        &__submit {
            max-width: 25em;
            width: 100%;
        }

        &__username {
            padding: 1em 0.5em;

        }

        &__submit {
            display: flex;
            justify-content: center;
            padding: 2em 0 2em 0;
        }

        &__form-element {
            padding: 1em 2em;
            width: 100%;
            border-radius: 3em;
            border: none;
            outline: none;
            font-weight: 600;
        }

        &__input {
            color: white;
            background-color: #0E1A10;

        }

        &__button {
            text-align: center;
            color: white;
            font-size: 1em;
            background-color: #00B27C;
        }

        &__recover {
            width: 100%;
            max-width: 20em;
            padding: 0.5em 2em 2em 2em;
            text-align: left;
        }

        &__forgot {
            font-size: 0.8em;
        }

        &__login {
            padding-top: 1.2em;
            font-size: 0.8em;
        }

        &__login-link {
            padding-left: 0.75em;
        }

        &__link {
            color: #00B27C;
            font-weight: 300;
        }

    }


</style>